// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__82wHA {
  border-bottom: 0.1rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: -16px !important;
}

.styles_tituloContainer__MyNCl {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
  margin-top: -28px !important;
}

.styles_titulo__clBwx {
  font-size: 44px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_botaoContainer__15a2F {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
}

.styles_botaoNovo__Z0LHE {
  width: 190px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 14px !important;
  margin-top: 20px !important;
  margin-left: 32% !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__Z0LHE:hover {
  transform: scale(0.95) !important;
}

.styles_tituloPopup__tuap9 {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_tituloPopupContainer__izUjp {
  display: flex !important;
  align-items: center !important;
}

.styles_tituloPopupContainerConciliacao__nWisG {
  align-items: center !important;
  display: flex !important;
  justify-content: space-between !important;
}

.styles_nomeTituloPopupContainerConciliacao__khSij {
  align-items: center !important;
  display: flex !important;
}

.styles_botoesConciliacao__gyMIE {
  background: #0f2047 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  margin-left: 1rem !important;
  transition: all 0.3s ease !important;
}

.styles_botoesConciliacao__gyMIE:hover:not(:disabled) {
  background: #0f2047 !important;
  transform: scale(0.95) !important;
}

.styles_botoesConciliacao__gyMIE:disabled,
.styles_botoesConciliacao__gyMIE.styles_Mui-disabled__axrpa {
  opacity: 1 !important;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  background-color: rgba(15, 32, 71, 0.45) !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.styles_botoesConciliacao__gyMIE:disabled .styles_MuiCircularProgress-root__RwyrV,
.styles_botoesConciliacao__gyMIE.styles_Mui-disabled__axrpa .styles_MuiCircularProgress-root__RwyrV,
.styles_botoesConciliacao__gyMIE:disabled .styles_MuiSvgIcon-root__JEkv4,
.styles_botoesConciliacao__gyMIE.styles_Mui-disabled__axrpa .styles_MuiSvgIcon-root__JEkv4 {
  color: #ffffff !important;
}

.styles_botoesPopupGeral__pglyK {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_dialogConciliacaoContent__QgoqF {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  padding: 0.5rem 1.5rem 0 !important;
}

.styles_tabelaConciliacaoWrapper__ZgXvt {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.styles_tabelaConciliacaoScroll__6HOfP {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto !important;
  max-height: none !important;
}

.styles_rodapeConciliacao__DttPu {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 1.5rem;
  row-gap: 0.35rem;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  border-top: 1px solid #e8ecf2;
  padding: 0.65rem 1.5rem 1.25rem;
  background: #fff;
}

.styles_rodapeConciliacaoSaldos__OY5YW {
  grid-column: 1;
  grid-row: 1 / 3;
  align-self: center;
  min-width: 0;
  overflow: hidden;
}

.styles_rodapeConciliacaoPaginacao__vcgMQ {
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  max-width: 100%;
  overflow: hidden;
}

.styles_rodapeConciliacaoBotoes__pPgIp {
  grid-column: 2;
  grid-row: 2;
  justify-self: end;
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
}

.styles_rodapeConciliacaoBotoes__pPgIp .styles_botoesConciliacao__gyMIE {
  margin-left: 0 !important;
}

.styles_rodapeConciliacaoBotoes__pPgIp .styles_botoesConciliacao__gyMIE + .styles_botoesConciliacao__gyMIE,
.styles_rodapeConciliacaoBotoes__pPgIp .styles_botoesConciliacao__gyMIE + .styles_botaoPopupCancelar__9RoW4,
.styles_rodapeConciliacaoBotoes__pPgIp .styles_botaoPopupCancelar__9RoW4 {
  margin-left: 0 !important;
}

.styles_capaSaldoConciliacao__doB5T {
  display: flex !important;
  flex-direction: column !important;
  gap: 0.2rem !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

.styles_capaSaldoLinha__UGpli {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: flex-start !important;
  gap: 1.25rem 2rem !important;
}

.styles_capaSaldoItem__DSjyd {
  display: flex !important;
  flex-direction: column !important;
  gap: 0.05rem !important;
  min-width: 5.5rem !important;
}

.styles_capaSaldoRotulo__UA2Jf {
  font-family: "Inter", sans-serif !important;
  font-size: 0.625rem !important;
  color: #5c6b8a !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  line-height: 1.2 !important;
}

.styles_capaSaldoValor__od33x {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  color: #0f2047 !important;
  line-height: 1.25 !important;
}

.styles_capaSaldoDiferencaOk__99RsM {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  color: #2e7d32 !important;
  line-height: 1.25 !important;
}

.styles_capaSaldoDiferencaErro__v06of {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  color: #c62828 !important;
  line-height: 1.25 !important;
}

.styles_capaSaldoDiferencaNeutro__O6\\+yE {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  color: #757575 !important;
  line-height: 1.25 !important;
}

.styles_capaSaldoIndisponivel__7-EFR {
  font-family: "Inter", sans-serif !important;
  font-size: 0.75rem !important;
  color: #757575 !important;
  font-style: italic !important;
  min-width: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.styles_modalLoadingOverlay__DxBYk {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.65);
  pointer-events: all;
}

.styles_botaoPopupSalvar__GMJX2 {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__GMJX2:hover:not(:disabled) {
  transform: scale(0.95) !important;
}

.styles_botaoPopupSalvar__GMJX2:disabled,
.styles_botaoPopupSalvar__GMJX2.styles_Mui-disabled__axrpa {
  opacity: 1 !important;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  background-color: rgba(15, 32, 71, 0.45) !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.styles_botaoPopupSalvar__GMJX2:disabled .styles_MuiCircularProgress-root__RwyrV,
.styles_botaoPopupSalvar__GMJX2.styles_Mui-disabled__axrpa .styles_MuiCircularProgress-root__RwyrV,
.styles_botaoPopupSalvar__GMJX2:disabled .styles_MuiSvgIcon-root__JEkv4,
.styles_botaoPopupSalvar__GMJX2.styles_Mui-disabled__axrpa .styles_MuiSvgIcon-root__JEkv4 {
  color: #ffffff !important;
}

.styles_botaoPopupCancelar__9RoW4 {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__9RoW4:hover:not(:disabled) {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__9RoW4:disabled,
.styles_botaoPopupCancelar__9RoW4.styles_Mui-disabled__axrpa {
  opacity: 1 !important;
  color: #0f2047 !important;
  -webkit-text-fill-color: #0f2047 !important;
  background-color: rgba(255, 255, 255, 0.85) !important;
  border-color: rgba(15, 32, 71, 0.35) !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.styles_botaoPopupCancelar__9RoW4:disabled .styles_MuiCircularProgress-root__RwyrV,
.styles_botaoPopupCancelar__9RoW4.styles_Mui-disabled__axrpa .styles_MuiCircularProgress-root__RwyrV {
  color: #0f2047 !important;
}

.styles_txtBuscaTabela__njS\\+O {
  margin-top: 20px !important;
  margin-left: 32% !important;
}

.styles_iconeBusca__wGz-u {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
  margin-left: 240px !important;
}

.styles_iconeExclusao__hnviX {
  color: #ff0000 !important;
}

.styles_textoExclusao__wI2mY {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
}

.styles_tituloExclusao__xEecN {
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  font-size: 44px !important;
}

.styles_iconeTabela__r204A {
  color: #0f2047 !important;
  font-size: 28px !important;
}

.styles_headerTabela__K-6C8 {
  background-color: #0f2047 !important;
  position: sticky;
  top: 0;
  z-index: 1; /* Garante que o cabeçalho fique acima das outras linhas da tabela */
}

.styles_itemHeaderTabela__K2ybI {
  color: #ffffff !important;
  font-weight: bold !important;
}

.styles_botaoPopupExcluir__cHfcd {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  margin-right: 7%;
  margin-bottom: 4%;
}

.styles_botaoPopupExcluir__cHfcd:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelarExclusao__p6G1c {
  width: 120px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  margin-right: 4%;
  margin-bottom: 4%;
}

.styles_botaoPopupCancelarExclusao__p6G1c:hover {
  transform: scale(0.95) !important;
}

.styles_inputPequeno__P30Te {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adicione mais estilos conforme necessário */
}



.styles_caixaDeTexto__knm8c {
  margin: 200px 70 !important;
  height: 30px !important;
}




.styles_botaoVoltar__37-7Y {
  background-color: #0f2047;
  color: #ffffff;
  border-color: #ffffff;
  border-width: 1px;
  border-style: solid;
  font-family: "Inter";
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
  height: 36px;
}

.styles_botaoVoltar__37-7Y:hover {
  background-color: #0f2047;
  color: #ffffff;
}


.styles_labelPequeno__2HgcD {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
}

.styles_placeholder__6L8c4 {
  font-size: 12px;
  /* Ajuste o valor conforme necessário */
  /* Outros estilos do placeholder, se necessário */
}

.styles_space__dlARo{
  margin-top: 1rem;
}

.styles_MuiTableHead-root__oNOBB {
  background-color: #0f2047 !important;
}

.styles_selectContainerBanks__PMtzj{
  align-items: center;
  background: #ffffff;
  display: flex;
  margin-top: 1rem;
}

.styles_iconSearch__53z2U{
  align-items: center !important;
  color: #18316e !important;
  display: flex !important;
  font-size: 1.8rem !important;
  margin-right: .5rem !important;
}

.styles_btnContainer__zos6c{
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.styles_btnModal__G\\+rZ2{
  border: 1px solid #18316e !important;
  &.styles_cancelar__gMlSI{
    background: #ffffff !important;
    color: #18316e !important;
  }
  &.styles_prosseguir__KM01v{
    background: #18316e !important;
    color: #ffffff !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ExtratoBancário/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,mDAAmD;EACnD,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,mDAAmD;EACnD,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,sDAAsD;EACtD,+CAA+C;EAC/C,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,UAAU,EAAE,oEAAoE;AAClF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;;;AAIA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;;;;AAKA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;AACF","sourcesContent":[".linhaTitulo {\n  border-bottom: 0.1rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: -16px !important;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n  margin-top: -28px !important;\n}\n\n.titulo {\n  font-size: 44px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.botaoContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n}\n\n.botaoNovo {\n  width: 190px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 14px !important;\n  margin-top: 20px !important;\n  margin-left: 32% !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.tituloPopupContainerConciliacao {\n  align-items: center !important;\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.nomeTituloPopupContainerConciliacao {\n  align-items: center !important;\n  display: flex !important;\n}\n\n.botoesConciliacao {\n  background: #0f2047 !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  margin-left: 1rem !important;\n  transition: all 0.3s ease !important;\n}\n\n.botoesConciliacao:hover:not(:disabled) {\n  background: #0f2047 !important;\n  transform: scale(0.95) !important;\n}\n\n.botoesConciliacao:disabled,\n.botoesConciliacao.Mui-disabled {\n  opacity: 1 !important;\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n  background-color: rgba(15, 32, 71, 0.45) !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.botoesConciliacao:disabled .MuiCircularProgress-root,\n.botoesConciliacao.Mui-disabled .MuiCircularProgress-root,\n.botoesConciliacao:disabled .MuiSvgIcon-root,\n.botoesConciliacao.Mui-disabled .MuiSvgIcon-root {\n  color: #ffffff !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.dialogConciliacaoContent {\n  flex: 1 1 auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n  min-height: 0 !important;\n  overflow: hidden !important;\n  box-sizing: border-box !important;\n  padding: 0.5rem 1.5rem 0 !important;\n}\n\n.tabelaConciliacaoWrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.tabelaConciliacaoScroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto !important;\n  max-height: none !important;\n}\n\n.rodapeConciliacao {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-rows: auto auto;\n  align-items: center;\n  column-gap: 1.5rem;\n  row-gap: 0.35rem;\n  flex-shrink: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-top: 1px solid #e8ecf2;\n  padding: 0.65rem 1.5rem 1.25rem;\n  background: #fff;\n}\n\n.rodapeConciliacaoSaldos {\n  grid-column: 1;\n  grid-row: 1 / 3;\n  align-self: center;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.rodapeConciliacaoPaginacao {\n  grid-column: 2;\n  grid-row: 1;\n  justify-self: end;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.rodapeConciliacaoBotoes {\n  grid-column: 2;\n  grid-row: 2;\n  justify-self: end;\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rodapeConciliacaoBotoes .botoesConciliacao {\n  margin-left: 0 !important;\n}\n\n.rodapeConciliacaoBotoes .botoesConciliacao + .botoesConciliacao,\n.rodapeConciliacaoBotoes .botoesConciliacao + .botaoPopupCancelar,\n.rodapeConciliacaoBotoes .botaoPopupCancelar {\n  margin-left: 0 !important;\n}\n\n.capaSaldoConciliacao {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0.2rem !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n}\n\n.capaSaldoLinha {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important;\n  align-items: flex-start !important;\n  gap: 1.25rem 2rem !important;\n}\n\n.capaSaldoItem {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0.05rem !important;\n  min-width: 5.5rem !important;\n}\n\n.capaSaldoRotulo {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.625rem !important;\n  color: #5c6b8a !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.03em !important;\n  line-height: 1.2 !important;\n}\n\n.capaSaldoValor {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.8125rem !important;\n  font-weight: 600 !important;\n  color: #0f2047 !important;\n  line-height: 1.25 !important;\n}\n\n.capaSaldoDiferencaOk {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.8125rem !important;\n  font-weight: 700 !important;\n  color: #2e7d32 !important;\n  line-height: 1.25 !important;\n}\n\n.capaSaldoDiferencaErro {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.8125rem !important;\n  font-weight: 700 !important;\n  color: #c62828 !important;\n  line-height: 1.25 !important;\n}\n\n.capaSaldoDiferencaNeutro {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.8125rem !important;\n  font-weight: 600 !important;\n  color: #757575 !important;\n  line-height: 1.25 !important;\n}\n\n.capaSaldoIndisponivel {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.75rem !important;\n  color: #757575 !important;\n  font-style: italic !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.modalLoadingOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.65);\n  pointer-events: all;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover:not(:disabled) {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupSalvar:disabled,\n.botaoPopupSalvar.Mui-disabled {\n  opacity: 1 !important;\n  color: #ffffff !important;\n  -webkit-text-fill-color: #ffffff !important;\n  background-color: rgba(15, 32, 71, 0.45) !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.botaoPopupSalvar:disabled .MuiCircularProgress-root,\n.botaoPopupSalvar.Mui-disabled .MuiCircularProgress-root,\n.botaoPopupSalvar:disabled .MuiSvgIcon-root,\n.botaoPopupSalvar.Mui-disabled .MuiSvgIcon-root {\n  color: #ffffff !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover:not(:disabled) {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar:disabled,\n.botaoPopupCancelar.Mui-disabled {\n  opacity: 1 !important;\n  color: #0f2047 !important;\n  -webkit-text-fill-color: #0f2047 !important;\n  background-color: rgba(255, 255, 255, 0.85) !important;\n  border-color: rgba(15, 32, 71, 0.35) !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.botaoPopupCancelar:disabled .MuiCircularProgress-root,\n.botaoPopupCancelar.Mui-disabled .MuiCircularProgress-root {\n  color: #0f2047 !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 20px !important;\n  margin-left: 32% !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n  margin-left: 240px !important;\n}\n\n.iconeExclusao {\n  color: #ff0000 !important;\n}\n\n.textoExclusao {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n}\n\n.tituloExclusao {\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  font-size: 44px !important;\n}\n\n.iconeTabela {\n  color: #0f2047 !important;\n  font-size: 28px !important;\n}\n\n.headerTabela {\n  background-color: #0f2047 !important;\n  position: sticky;\n  top: 0;\n  z-index: 1; /* Garante que o cabeçalho fique acima das outras linhas da tabela */\n}\n\n.itemHeaderTabela {\n  color: #ffffff !important;\n  font-weight: bold !important;\n}\n\n.botaoPopupExcluir {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  margin-right: 7%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupExcluir:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelarExclusao {\n  width: 120px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n  margin-right: 4%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupCancelarExclusao:hover {\n  transform: scale(0.95) !important;\n}\n\n.inputPequeno {\n  width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  /* Adicione mais estilos conforme necessário */\n}\n\n\n\n.caixaDeTexto {\n  margin: 200px 70 !important;\n  height: 30px !important;\n}\n\n\n\n\n.botaoVoltar {\n  background-color: #0f2047;\n  color: #ffffff;\n  border-color: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  font-family: \"Inter\";\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n  height: 36px;\n}\n\n.botaoVoltar:hover {\n  background-color: #0f2047;\n  color: #ffffff;\n}\n\n\n.labelPequeno {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n}\n\n.placeholder {\n  font-size: 12px;\n  /* Ajuste o valor conforme necessário */\n  /* Outros estilos do placeholder, se necessário */\n}\n\n.space{\n  margin-top: 1rem;\n}\n\n.MuiTableHead-root {\n  background-color: #0f2047 !important;\n}\n\n.selectContainerBanks{\n  align-items: center;\n  background: #ffffff;\n  display: flex;\n  margin-top: 1rem;\n}\n\n.iconSearch{\n  align-items: center !important;\n  color: #18316e !important;\n  display: flex !important;\n  font-size: 1.8rem !important;\n  margin-right: .5rem !important;\n}\n\n.btnContainer{\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.btnModal{\n  border: 1px solid #18316e !important;\n  &.cancelar{\n    background: #ffffff !important;\n    color: #18316e !important;\n  }\n  &.prosseguir{\n    background: #18316e !important;\n    color: #ffffff !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__82wHA`,
	"tituloContainer": `styles_tituloContainer__MyNCl`,
	"titulo": `styles_titulo__clBwx`,
	"botaoContainer": `styles_botaoContainer__15a2F`,
	"botaoNovo": `styles_botaoNovo__Z0LHE`,
	"tituloPopup": `styles_tituloPopup__tuap9`,
	"tituloPopupContainer": `styles_tituloPopupContainer__izUjp`,
	"tituloPopupContainerConciliacao": `styles_tituloPopupContainerConciliacao__nWisG`,
	"nomeTituloPopupContainerConciliacao": `styles_nomeTituloPopupContainerConciliacao__khSij`,
	"botoesConciliacao": `styles_botoesConciliacao__gyMIE`,
	"Mui-disabled": `styles_Mui-disabled__axrpa`,
	"MuiCircularProgress-root": `styles_MuiCircularProgress-root__RwyrV`,
	"MuiSvgIcon-root": `styles_MuiSvgIcon-root__JEkv4`,
	"botoesPopupGeral": `styles_botoesPopupGeral__pglyK`,
	"dialogConciliacaoContent": `styles_dialogConciliacaoContent__QgoqF`,
	"tabelaConciliacaoWrapper": `styles_tabelaConciliacaoWrapper__ZgXvt`,
	"tabelaConciliacaoScroll": `styles_tabelaConciliacaoScroll__6HOfP`,
	"rodapeConciliacao": `styles_rodapeConciliacao__DttPu`,
	"rodapeConciliacaoSaldos": `styles_rodapeConciliacaoSaldos__OY5YW`,
	"rodapeConciliacaoPaginacao": `styles_rodapeConciliacaoPaginacao__vcgMQ`,
	"rodapeConciliacaoBotoes": `styles_rodapeConciliacaoBotoes__pPgIp`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__9RoW4`,
	"capaSaldoConciliacao": `styles_capaSaldoConciliacao__doB5T`,
	"capaSaldoLinha": `styles_capaSaldoLinha__UGpli`,
	"capaSaldoItem": `styles_capaSaldoItem__DSjyd`,
	"capaSaldoRotulo": `styles_capaSaldoRotulo__UA2Jf`,
	"capaSaldoValor": `styles_capaSaldoValor__od33x`,
	"capaSaldoDiferencaOk": `styles_capaSaldoDiferencaOk__99RsM`,
	"capaSaldoDiferencaErro": `styles_capaSaldoDiferencaErro__v06of`,
	"capaSaldoDiferencaNeutro": `styles_capaSaldoDiferencaNeutro__O6+yE`,
	"capaSaldoIndisponivel": `styles_capaSaldoIndisponivel__7-EFR`,
	"modalLoadingOverlay": `styles_modalLoadingOverlay__DxBYk`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__GMJX2`,
	"txtBuscaTabela": `styles_txtBuscaTabela__njS+O`,
	"iconeBusca": `styles_iconeBusca__wGz-u`,
	"iconeExclusao": `styles_iconeExclusao__hnviX`,
	"textoExclusao": `styles_textoExclusao__wI2mY`,
	"tituloExclusao": `styles_tituloExclusao__xEecN`,
	"iconeTabela": `styles_iconeTabela__r204A`,
	"headerTabela": `styles_headerTabela__K-6C8`,
	"itemHeaderTabela": `styles_itemHeaderTabela__K2ybI`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__cHfcd`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__p6G1c`,
	"inputPequeno": `styles_inputPequeno__P30Te`,
	"caixaDeTexto": `styles_caixaDeTexto__knm8c`,
	"botaoVoltar": `styles_botaoVoltar__37-7Y`,
	"labelPequeno": `styles_labelPequeno__2HgcD`,
	"placeholder": `styles_placeholder__6L8c4`,
	"space": `styles_space__dlARo`,
	"MuiTableHead-root": `styles_MuiTableHead-root__oNOBB`,
	"selectContainerBanks": `styles_selectContainerBanks__PMtzj`,
	"iconSearch": `styles_iconSearch__53z2U`,
	"btnContainer": `styles_btnContainer__zos6c`,
	"btnModal": `styles_btnModal__G+rZ2`,
	"cancelar": `styles_cancelar__gMlSI`,
	"prosseguir": `styles_prosseguir__KM01v`
};
export default ___CSS_LOADER_EXPORT___;
